import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CallFab from "./CallFab";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-atc-paper">
      <Header />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
      <CallFab />
    </div>
  );
}
